<template>
  <div>
    <div class="inst-title">재료 소모량 최적화 검사</div>
    <pre class="inst-desc">
3D모델의 크기에 비해 부피가 매우 높게 측정됩니다
제작은 가능하나 아래의 방법으로 효율적인 생산을 권장드립니다.</pre
    >

    <div class="inst-subtitle">[해결방법]</div>

    <pre
      class="inst-desc"
    >· 내부비움으로 최적화 권장<br>· 모델 내부 구조 변경 으로 최적화 권장</pre>
  </div>
</template>

<script setup></script>
